module.exports = "export default __webpack_public_path__ + &quot;9dbef4241df38082f0c394d77d616031.svg&quot;;"